import React from "react";
import CardUI from "../../../widgets/layout/CardUI";
import SpinnerComponentUI from "../../../components/common/SpinnerComponentUI";
import IconButtonUI from "../../../widgets/action/IconButtonUI";
import SuTransactionInnerListUI
  from "../../../components/superUser/transaction/SuTransactionInnerListUI";
import TxnsLoanBalanceModalSF from "../../../components/superUser/virtualTxn/TxnsLoanBalanceModalSF";
import SuperUserLoanPageSF from "../../../templates/SuperUserLoanPageSF";
const LoanTransactionListPageUI = ({
  context, errorList, transactionList, transactionTypeTotalList, loan, onRefreshClick, txnList, onDownloadClick,
  updateLoanBalanceMode, onUpdateLoanBalanceClick, onUpdateLoanBalanceCancelClick, selectedTxnId
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_disb_lst'
    headerText='Loan Transactions' centered={!transactionTypeTotalList && !transactionList && !errorList}
    loan={loan} page='loanTxns'
  >
    {
      (!transactionList || !transactionTypeTotalList || !errorList) &&
      <SpinnerComponentUI />
    }
    <span className='g_flex_left g_flex_h'>
      <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
      <IconButtonUI icon='icon-download' onClick={onDownloadClick} label='Download' />
      <span className='g_m_left_100 g_large'><b>Loan Transactions</b></span>
    </span>
    {
      transactionTypeTotalList && transactionTypeTotalList.length > 0 &&
      <BigNumberUI totalList={transactionTypeTotalList} />
    }
    {
      transactionList &&
      <SuTransactionInnerListUI txnList={transactionList} context={context} onUpdateLoanBalanceClick={onUpdateLoanBalanceClick} />
    }
    {
      <TxnsLoanBalanceModalSF context={context} updateLoanBalanceMode={updateLoanBalanceMode} selectedTxnId={selectedTxnId}
        onRefreshClick={onRefreshClick} onLoanBalanceCancelClick={onUpdateLoanBalanceCancelClick} />
    }
  </SuperUserLoanPageSF>

const BigNumberUI = ({ totalList }) =>
  <CardUI className='g_m_bottom_100'>
    <div className='g_flex_h'>
      {
        totalList.filter(t => t.total != 0).map((total, i) =>
          <div key={i}>
            <span className='g_flex_v g_text_center'>
              <span className='g_xxxlarge'><b>{total.totalF5}</b></span>
              <span>{total.name}</span>
            </span>
          </div>
        )
      }
    </div>
  </CardUI>

export default LoanTransactionListPageUI